
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Function = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Function" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M11.247 7.841l2.147-3.151h-1.535l-1.466 2.253L8.938 4.69H7l.1-.5a1.722 1.722 0 01.367-.821.839.839 0 01.633-.251 2.188 2.188 0 01.785.164l.351-1.026A2.94 2.94 0 008.017 2a2.094 2.094 0 00-1.481.487 3.122 3.122 0 00-.776 1.64l-.121.536-1.12.443-.12.617h1.034L4.18 11.681q-.248 1.2-1.022 1.194a2.232 2.232 0 01-.658-.117v1.106a2.351 2.351 0 00.86.136 1.874 1.874 0 001.375-.518 3.137 3.137 0 00.755-1.619l1.288-6.136H8.1l1.432 2.115-2.246 3.291h1.536l1.571-2.412 1.572 2.411H13.5z" />
</svg>
    </HvIconBase>
)};

Function.propTypes = HvIconBase.propTypes;

export default Function;